import { RouteRecordRaw } from 'vue-router';
import { ViewDraftPage } from '@/pages/registry-management';

export const routeName = 'GestaoRegistrosRascunhoVisualizar';

export const route: RouteRecordRaw = {
  path: 'gestao-registros/rascunhos/:id',
  name: routeName,
  component: ViewDraftPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Visualizar Rascunho',
    dynamicBreadcrumb: true,
    breadcrumbTrail: [
      { name: 'Gestão de Registros', path: '/gestao-registros' },
      { name: 'Modelos', path: '/gestao-registros/modelos?tab=rascunhos' },
      { name: 'Visualizar Rascunho' },
    ],
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
